import jwt from 'jsonwebtoken';
import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Integrations from '@/components/Integrations';
import Workflows from '@/components/Workflows';
import Events from '@/components/Events';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/events',
      name: 'Events',
      component: Events,
    },
    {
      path: '/integrations',
      name: 'Integrations',
      component: Integrations,
    },
    {
      path: '/workflows',
      name: 'Workflows',
      component: Workflows,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const { token } = localStorage;

  if (to.name === 'Home') return next();

  if (!token) return this.push('Home');

  if (new Date(jwt.decode(token).exp * 1000) < new Date()) {
    const event = document.createEvent('Event');
    event.initEvent('auth', true, true);
    document.dispatchEvent(event);
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js